import { axiosTemplate } from '../../axiosTemplate';
import * as qsLibrary from 'qs';
export var SupportedMimeTypes;
(function (SupportedMimeTypes) {
    SupportedMimeTypes["GeoJson"] = "application/vnd.geo+json";
    SupportedMimeTypes["GeoBuf"] = "application/octet-stream";
    SupportedMimeTypes["KML"] = "application/vnd.google-earth.kml+xml";
    SupportedMimeTypes["CSV"] = "text/csv";
    SupportedMimeTypes["Blitzen"] = "application/vnd.metraweather.blitzen";
    SupportedMimeTypes["BlitzenV1"] = "application/vnd.metraweather.blitzen.v1";
    SupportedMimeTypes["BlitzenV2"] = "application/vnd.metraweather.blitzen.v2";
    SupportedMimeTypes["BlitzenV3"] = "application/vnd.metraweather.blitzen.v3";
    SupportedMimeTypes["GeoJsonV2"] = "application/vnd.metraweather.lightning.geo+json.v2";
    SupportedMimeTypes["GeoJsonV3"] = "application/vnd.metraweather.lightning.geo+json.v3";
    SupportedMimeTypes["VectorTile"] = "application/vnd.mapbox-vector-tile";
})(SupportedMimeTypes || (SupportedMimeTypes = {}));
const qsStringify = (qs) => {
    return qs ? `?${qsLibrary.stringify(qs, { arrayFormat: 'comma' })}` : '';
};
export const lightning = {
    endpoints: {
        test: `https://lightning.api.metraweather.com/v4`,
        acceptance: `https://lightning.api.metraweather.com/v4`,
        prod: `https://lightning.api.metraweather.com/v4`,
    },
    http: {
        strikes: ({ queryString, mimeType, stage, metjwt, cancelToken }) => {
            const qs = qsStringify(queryString);
            const headers = mimeType ? { headers: { Accept: mimeType } } : {};
            return axiosTemplate(metjwt, cancelToken).get(`${lightning.endpoints[stage]}/strikes${qs}`, headers);
        },
        vectorTilesMapboxURL: ({ queryString, stage }) => {
            const qs = qsStringify(queryString);
            return `${lightning.endpoints[stage]}/strikes/tile/{z}/{x}/{y}${qs}`;
        },
        metaTile: ({ stage, metjwt, cancelToken }) => {
            return axiosTemplate(metjwt, cancelToken).get(`${lightning.endpoints[stage]}/strikes/tile`);
        },
        metaDirections: ({ stage, metjwt, cancelToken }) => {
            return axiosTemplate(metjwt, cancelToken).get(`${lightning.endpoints[stage]}/directions`);
        },
        metaProviders: ({ stage, metjwt, cancelToken }) => {
            return axiosTemplate(metjwt, cancelToken).get(`${lightning.endpoints[stage]}/providers`);
        },
        metaStatus: ({ stage, metjwt, cancelToken }) => {
            return axiosTemplate(metjwt, cancelToken).get(`${lightning.endpoints[stage]}/status`);
        },
    },
};
